export class ScaleFactor {
    public applyThreeScaleFactor(value: number): number {
        return value / (100/7);
    }
}